/**
 * The Live tab before it has containers to show: loading, the plan that
 * could not be loaded (with Retry), or a day with nothing planned.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

const BOX = 'rounded-lg border border-border/60 bg-card p-4 text-sm text-muted-foreground';

export const LiveLoading: FC = () => (
  <div className="flex flex-col gap-2">
    {[0, 1, 2].map((i) => (
      <div key={i} className="h-14 animate-pulse rounded-lg bg-muted/60" />
    ))}
  </div>
);

export const LiveFailed: FC<{ onRetry?: () => void }> = ({ onRetry }) => (
  <p className={BOX}>
    Today&apos;s plan could not be loaded.{' '}
    {onRetry ? (
      <button type="button" onClick={onRetry} className="font-medium text-primary hover:underline">
        Retry
      </button>
    ) : null}
  </p>
);

export const LiveEmpty: FC = () => <p className={BOX}>Nothing is planned today — see the Day timeline for why.</p>;
